<template>
    <div v-if="board">
        <v-divider class="grey darken-4"/>
        <div class="pa-12px py-md-14px grey lighten-4">
            <strong class="font-size-16">{{ board.subject }}</strong>
        </div>
        <v-divider />
        <div class="pa-12px py-md-14px">
            <span class="font-size-14 font-size-md-16"><strong class="font-weight-medium">작성일자 : </strong>{{ $dayjs(board.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</span>
        </div>
        <v-divider />

        <div class="font-size-14 font-size-md-16 pa-12px py-20px min-h-200px">
            <p v-html="board.content"></p>
        </div>
        <v-divider />
        <div v-if="board.isComment">
            <div class="tit-wrap mb-10px mb-md-20px mt-4">
                <h3 class="tit tit--xs">댓글</h3>
            </div>
                    <!-- S: PC -->
            <div v-if="!$vuetify.breakpoint.mobile">
                <v-data-table :headers="commentHeaders" :items="comments" disable-sort hide-default-footer class="v-data-table--default">
                    <span slot="item.no" slot-scope="{item}">{{ (page - 1) * limit + +comments.indexOf(item) + 1 }}</span>
                    <template slot="item.writer" slot-scope="{item}">{{ item.writer.username }}</template>
                    <template slot="item.createdAt" slot-scope="{item}">{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</template>
                    <template slot="item.content" slot-scope="{item}">
                        <v-row>
                            <v-col cols="11">
                                <span v-html="getDisplayedContent(item)" />
                            </v-col>
                            <v-spacer />
                            <v-col v-if="item.content.length > maxContentLength">
                                <v-icon v-if="!item.show" @click="item.show = true">mdi-chevron-down</v-icon>
                                <v-icon v-else @click="item.show = false">mdi-chevron-up</v-icon>
                            </v-col>
                        </v-row>
                    </template>
                    <template slot="item.actions" slot-scope="{item}">
                        <div class="v-btn--group--x-small">
                            <v-btn  v-if="item._member == payload?._user" @click="edit(item)" x-small color="secondary">수정</v-btn>
                            <v-btn v-if="item._member == payload?._user" @click="remove(item)" x-small outlined color="grey"><span class="grey--text text--darken-3">삭제</span></v-btn>
                        </div>
                    </template>
                </v-data-table>
            </div>
            <!-- E: PC -->
    
            <!-- S: 모바일 -->
            <div v-else>
            <v-divider class="grey darken-4"/>
            <template v-for="comment, index in comments">
                <v-divider v-if="index" :key="`divider${comment._id}`" class="grey lighten-1"/>
                <div :key="`title${comment._id}`" class="pa-12px py-md-14px">
                    <v-row no-gutters align="center" class="font-size-14 font-size-md-16">
                        <v-col cols="auto">
                            <span>{{ comment.writer.username }}</span>
                        </v-col>
                        <v-col cols="auto" class="d-flex"><v-divider vertical class="grey lighten-1 mx-8px" style="height:12px;" /></v-col>
                        <v-col cols="auto">
                            <span>{{ $dayjs(comment.createdAt).format("YYYY-MM-DD") }}</span>
                        </v-col>
                    </v-row>
                </div>

                <div :key="`content${comment._id}`" class="pa-12px py-md-14px grey lighten-4">
                    <span class="font-size-14 font-size-md-16">{{ comment.content }}</span>
                    <div v-if="comment._member == payload?._user" class="mt-10px">
                        <div class="v-btn--group--x-small">
                            <v-btn @click="edit(comment)" x-small color="secondary">수정</v-btn>
                            <v-btn @click="remove(comment)" x-small outlined class="white" style="border-color:#9e9e9e!important;"><span class="grey--text text--darken-3">삭제</span></v-btn>
                        </div>
                    </div>
                </div>
            </template>
            <v-divider class="grey lighten-1"/>
        </div>
            <!-- E: 모바일 -->
    
            <div class="mt-20px mt-md-30px">
                <v-pagination v-model="page" :length="pageCount" total-visible="11" @input="search" />
            </div>
    
            <div class="mt-20px mt-md-30px">
                <div class="pa-12px py-md-14px grey lighten-4">
                    <div class="mt-10px">
                        <v-row class="row--x-small">
                            <v-col>
                                <v-text-field v-model="comment.content" placeholder="댓글을 남겨주세요." outlined hide-details class="white" />
                            </v-col>
                            <v-col cols="auto">
                                <v-btn @click="save" color="primary" class="v-btn--input">댓글 등록</v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </div>
    
            <v-dialog v-model="dialog" max-width="500">
                <v-card class="v-card--dialog v-card--dialog--sm">
                    <div class="v-card--dialog__head">
                        <h3 class="tit tit--xs">댓글</h3>
                        <v-btn fab color="transparent" @click="dialog = false" class="v-card--dialog__close"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                    <div class="v-card--dialog__body">
                        <div>
                            <v-textarea v-model="comment.content" placeholder="기대평을 입력해주세요" persistent-placeholder outlined hide-details rows="8" />
                        </div>
                    </div>
                    <div class="v-card--dialog__foot">
                        <v-row class="row--x-small">
                            <v-spacer></v-spacer>
                            <v-col cols="auto">
                                <v-btn @click="save2" color="primary">등록</v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </v-card>
            </v-dialog>
        </div>
        <login-dialog ref="loginDialog" />
    </div>
</template>

<script>
import api from "@/api"
import LoginDialog from "@/components/client/login/login-dialog.vue";
export default {
    props: {
        board: { type: Object }
    },
    components: {
        LoginDialog
    },
    data() {
        return {
            dialog: false,

            page: 1,
            pageCount: 0,
            limit: 5,

            comments: [],
            comment: {},

            commentHeaders: [
                { text: "no", value: "no", align: "center", width: "5%" },
                { text: "댓글", value: "content", align: "center", width: "57%"  },
                { text: "작성자", value: "writer", align: "center", width: "14%" },
                { text: "작성일자", value: "createdAt", align: "center", width: "14%" },
                { text: "-", value: "actions", align: "center", width: "8%" },
            ],
            maxContentLength: 47
        }
    },
    async mounted() {
        await this.init();
    },
    methods: {
        async init() {
            await this.search();
            this.comment = { 
                _board: this.$route.params._board,
                content: null,
            }
        },
        async search() {
            let { summary, comments } = await api.v1.boards.comments.gets(this.$route.params._board, {
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                }
            })

            for (let i = 0; i < comments.length; i++) {
                let comment = comments[i]
                comment.show = false;
            }
            this.comments = comments
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },
        async save(){
            if(await this.$confirm("댓글을 등록하시겠습니까?")){
                this.login().then(async () => {
                    await api.v1.boards.comments.post(this.$route.params._board, this.comment)
                    alert("댓글이 등록되었습니다");
                    this.comment.content = null;
                    await this.search();
                });
            }
        },

        async save2(){
            if(await this.$confirm("댓글을 등록하시겠습니까?")){
                this.login().then(async () => {
                    await api.v1.boards.comments.put(this.$route.params._board, this.comment);
                    alert("댓글이 등록되었습니다");
                    this.comment.content = null;
                    this.dialog = false
                    await this.search();
                });
            }
        },
        async login(){
            return new Promise((resolve, reject) => {
                if(this.logon) resolve();
                else{
                    this.$refs.loginDialog.$off();
                    this.$refs.loginDialog.$on("login", _ => resolve());
                    this.$refs.loginDialog.$on("cancel", _ => reject());
                    this.$refs.loginDialog.open();
                }
            });
        },
        edit(comment){
            this.comment = { ...comment };
            this.dialog = true;
        },
        async remove(comment){
            if(await this.$confirm("댓글을 삭제하시겠습니까?")){
                await api.v1.boards.comments.delete(this.comment._id, comment);
                alert("댓글이 삭제되었습니다");
                await this.search();
            }
        },
        getDisplayedContent(comment) {
            if (comment.show) {
                return comment.content;
            }
            if (comment.content.length > this.maxContentLength) {
                return comment.content.slice(0, this.maxContentLength) + '...';
            }
            return comment.content;
        },
    },
    computed: {
        logon(){ return !!this.$store.state.accessToken },
        payload(){ return this.$store.state.payload; }
    }
}
</script>
